import request from '@/utils/request'
import { ConstConfig, AppType } from '@/utils'
import { getWXInfo, getToken } from '@/libs/cookie-storage'

export function login(userName, password) {
  const data = {
    username: userName,
    password: password
  }
  return request({
    url: ConstConfig.apiPath + '/Login.json',
    method: 'post',
    data: data
  })
}

export function smsLogin(userInfo) {
  let data = {
    mobile: userInfo.tel,
    sendCode: userInfo.sms
  }
  if (userInfo.password) {
    data.password = userInfo.password
  } else {
    data.action = 'fastBind'
  }
  return request({
    url: ConstConfig.apiPath + '/RegisterMobile.json',
    method: 'post',
    data
  })
}

export function sendSmsCode(tel) { // 注册时获取验证码
  const params = {
    mobile: tel,
    action: 'sendRegisterCode'
  }
  return request({
    url: ConstConfig.apiPath + '/RegisterMobile.json',
    method: 'post',
    data: params
  })
}

export function sendLoginSmsCode(tel) { // 登陆时获取验证码
  const params = {
    mobile: tel,
    action: 'sendFastBindCode'
  }
  return request({
    url: ConstConfig.apiPath + '/RegisterMobile.json',
    method: 'post',
    data: params
  })
}

export function changeBindingCode(tel) { // 手机换绑请求验证码
  const params = {
    loginType: 'mobile',
    mobile: tel,
    action: 'sendMobileCode'
  }
  return request({
    url: ConstConfig.apiPath + '/RegisterMobile.json',
    method: 'post',
    data: params
  })
}

export function changeBindingNewMobile(tel, code) { // 手机换绑注册新手机号
  const params = {
    loginType: 'mobile',
    loginName: tel,
    sendCode: code,
    link: true
  }
  return request({
    url: ConstConfig.apiPath + '/RegisterMobile.json',
    method: 'post',
    data: params
  })
}

export function getUserDetails(params) {
  return request({
    url: ConstConfig.apiPath + '/GetUser.json',
    method: 'get',
    params
  })
}

export function getPlayerIceHockeyCareer(params) {
  return request({
    url: ConstConfig.apiPath + '/GetPlayerIceHockeyCareer.json',
    method: 'get',
    params
  })
}

export function personalHockeyDataExportPDF(params) {
  return request({
    url: ConstConfig.apiPath + '/PersonalHockeyDataExportPDF.json',
    method: 'get',
    params
  })
}

export function logOut() {
  return request({
    url: ConstConfig.apiPath + '/Logout.json',
    method: 'get'
  })
}

export function checkSSO() {
  return request({
    url: ConstConfig.authApiPath + '/checkSSO.do',
    method: 'get'
  })
}

/* qiniu token */
export function getQiniuUploadToken() {
  const params = {
    deadline: 3600,
    scope: 'bjh-static',
    strict: true
  }
  return request({
    url: ConstConfig.apiPath + '/GetQiniuUploadToken.json',
    method: 'get',
    params
  })
}

/* upload images */
export function uploadImage(data) {
  return request({
    url: 'http://up-z1.qiniup.com',
    method: 'post',
    data
  })
}

export function getPlayerList(data) {
  return request({
    url: ConstConfig.apiPath + '/GetPlayerList.json',
    method: 'post',
    data
  })
}

export function getCoachList(data) {
  return request({
    url: ConstConfig.apiPath + '/GetCoachList.json',
    method: 'post',
    data
  })
}

export function forgotPassword(data) {
  data.loginType = data.loginType || 'mobile'
  return request({
    url: ConstConfig.apiPath + '/ForgotPassword.json',
    method: 'post',
    data
  })
}

export function resetPassword(data) {
  data.loginType = 'mobile'
  return request({
    url: ConstConfig.apiPath + '/ResetPassword.json',
    method: 'post',
    data
  })
}

export function updateRegisterMobile(data) {
  data.loginType = 'mobile'
  return request({
    url: ConstConfig.apiPath + '/UnRegister.json',
    method: 'post',
    data
  })
}

export function getWeChatSignature(data) {
  return request({
    url: ConstConfig.apiPath + '/GetWechatSign.json',
    method: 'post',
    data
  })
}

export function getPlayerAuditList() {
  return [
    { value: '', label: '全部' },
    { value: 0, label: '待确认' },
    { value: 1, label: '未通过' },
    { value: 2, label: '通过' }
  ]
}



// WEBPACK FOOTER //
// ./src/api/user.js